import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import RadioButton from 'src/components/RadioButton/RadioButton'
import { VirtualCardDeactivatingInIncrements } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface VirtualCardDeactivatingInFilterProps {
  selectedDeactivatingIn?: string
  onChange: (deactivatingIn: string) => void
}

const radioOptionCss = css`
  display: flex;
  align-items: center;
  gap: 8px;
`

const VirtualCardDeactivatingInFilter: React.FC<
  VirtualCardDeactivatingInFilterProps
> = ({ selectedDeactivatingIn = '', onChange }): React.ReactElement => {
  const translate = useTranslate()

  const renderOption = (
    value: string,
    label: string,
    testId: string,
  ): React.ReactElement => (
    <div css={radioOptionCss}>
      <RadioButton
        onClick={(): void => onChange(value)}
        isSelected={selectedDeactivatingIn === value}
        css={css`
          display: block;
        `}
        testId={testId}
        aria-label={translate(label)}
      />
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.regular,
          )}
        `}
      >
        {translate(label)}
      </div>
    </div>
  )

  return (
    <div
      role="radiogroup"
      aria-labelledby="filter-deactivating-within"
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        id="filter-deactivating-within"
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Cards Deactivating Within')}
      </div>
      {renderOption(
        VirtualCardDeactivatingInIncrements.in7Days,
        '7 days',
        '7daysRadio',
      )}
      {renderOption(
        VirtualCardDeactivatingInIncrements.in14Days,
        '14 days',
        '14daysRadio',
      )}
      {renderOption(
        VirtualCardDeactivatingInIncrements.in30Days,
        '30 days',
        '30daysRadio',
      )}
      {renderOption('', 'Any time', 'anytimeRadio')}
    </div>
  )
}

export default VirtualCardDeactivatingInFilter
